<template>
  <router-link
    class="event-card"
    :class="{ 'is-finished': item.finFlag }"
    :to="{ name: 'EventDetail', query: { id: item.id } }">
    <div class="thumb">
      <img v-bind:src="item.downloadUrl" alt="" loading="lazy" decoding="async">
      <span v-if="item.fullHouseFlag && !item.finFlag" class="badge badge-full">満員御礼</span>
    </div>
    <div class="body">
      <div class="date">
        <span class="date-label">日程</span>
        <span class="date-val">
          {{ item.startDateFmt }}<template v-if="item.endDateFmt && item.endDateFmt !== item.startDateFmt"> 〜 {{ item.endDateFmt }}</template>
        </span>
        <span v-if="item.finFlag" class="date-fin">終了</span>
      </div>
      <div class="title">{{ item.title }}</div>
      <span class="detail-btn">詳細を見る</span>
    </div>
  </router-link>
</template>

<script>
export default {
  data() {
    return {
      item: {}
    }
  },
  props: {
    value: String
  },
  mounted() {
    this.item = JSON.parse(this.value);
    this.setImageUrl();
    let fmtDatetime = this.toDateTime(this.item.startDatetime);
    this.item.startDateFmt = fmtDatetime.dateFmt;
    this.item.startDate = fmtDatetime.date;
    fmtDatetime = this.toDateTime(this.item.endDatetime);
    this.item.endDateFmt = fmtDatetime.dateFmt;
    this.item.endDate = fmtDatetime.date;

    this.item.finFlag = this.item.startDate.getTime() < new Date().getTime();
  },
  methods: {
    toDateTime(datetime) {
      var date = new Date(1970, 0, 1);
      date.setSeconds(datetime.seconds);
      date.setHours(date.getHours() + 9);
      return {
        dateFmt: date.getFullYear() + "/" + ("00" + (date.getMonth() + 1)).slice(-2) + "/" + ("00" + date.getDate()).slice(-2),
        date: date
      };
    },
    setImageUrl() {
      if (this.item.imageurl) {
        const bucket = "farmy-demo.appspot.com";
        const path = encodeURIComponent("events-contents-image/" + this.item.imageurl);
        this.item.downloadUrl = `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${path}?alt=media`;
      }
    },
  }
}
</script>

<style scoped>
.event-card {
  display: block;
  width: 100%;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  text-decoration: none;
  color: inherit;
  transition: transform 0.2s, box-shadow 0.2s;
}
.event-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.14);
}
.thumb {
  position: relative;
  aspect-ratio: 16 / 10;
  overflow: hidden;
  background: #f0ece1;
}
.thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.4s ease;
}
.event-card:hover .thumb img {
  transform: scale(1.06);
}
.badge {
  position: absolute;
  top: 12px;
  left: 12px;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.05em;
}
.badge-full {
  background: #c0392b;
}
.is-finished .thumb img {
  filter: grayscale(0.7);
  opacity: 0.8;
}
.body {
  padding: 14px 16px 18px;
  text-align: left;
}
.date {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}
.date-label {
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  background: #AF9453;
  padding: 2px 9px;
  border-radius: 5px;
  letter-spacing: 0.05em;
}
.date-val {
  font-size: 13px;
  color: #7a7466;
}
.date-fin {
  margin-left: auto;
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 700;
  color: #857f74;
  background: #eae5d8;
  padding: 2px 11px;
  border-radius: 999px;
  letter-spacing: 0.06em;
}
.title {
  color: #433f38;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  min-height: 45px;
  margin-bottom: 16px;
}
.is-finished .title {
  color: #9c968b;
}
.detail-btn {
  display: block;
  text-align: center;
  background: #AF9453;
  color: #fff;
  padding: 9px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  transition: filter 0.15s;
}
.event-card:hover .detail-btn {
  filter: brightness(1.08);
}
</style>
